import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_BUILD_FUND_TERMINATE: MijnRoute = {
    path: 'bouwdepot/beeindigen',
    navigationEvent: 'toBouwdepotBeeindigen',
    regex: /^\/hypotheek\/bouwdepot\/beeindigen$/,
    webcomponent: 'mijn-hypotheken-bouwdepot-webcomponent',
    internalPath: 'beeindigen'
};
